import React from "react";
import { Col, Row } from "react-bootstrap";
import { formatarData } from "../../../../components/Formatters/DateTime";
import useDebitoDetalhe from "../hooks/useDebitoDetalhe";

const DebitoDetalhe = ({ data, inscricao, tipoDebito }) => {
  const detalhes = useDebitoDetalhe(data, inscricao, tipoDebito);

  return (
    <div>
      <Row>
        <Col>
          {detalhes?.length > 0 ? (
            <div>
              <table className="table table-striped table-bordered" width="90%">
                <thead>
                  <tr>
                    <th>Documento</th>
                    <th>Chave/TADF</th>
                    <th>Origem Débito</th>
                    <th>Valor (R$)</th>
                    <th>ICMS (R$)</th>
                    <th>Cobrança</th>
                    <th>CNPJ Emitente/Destinatário</th>
                    <th>Razão Social</th>
                    <th>UF</th>
                    <th>Tipo Nota</th>
                    <th>Cod. Cob.</th>
                    <th>Cod. Rec.</th>
                    <th>DT Geração</th>
                  </tr>
                </thead>
                <tbody>
                  {detalhes?.map((debitoDetalhado) => (
                    <tr>
                      <td>{debitoDetalhado.documento}</td>
                      <td>{debitoDetalhado.chave}</td>
                      <td>
                        {debitoDetalhado.texto_Debito} {debitoDetalhado.numeroNotaSerie}
                      </td>
                      <td className="text-right">
                        {debitoDetalhado.valorNota.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                      </td>
                      <td className="text-right">
                        {debitoDetalhado.valorDebitoIcms.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                      </td>
                      <td>{debitoDetalhado.flagCobranca}</td>
                      <td>{debitoDetalhado.cnpjEmitenteDestinatario}</td>
                      <td>{debitoDetalhado.razaoSocial}</td>
                      <td>{debitoDetalhado.uf}</td>
                      <td>{debitoDetalhado.tipoNota}</td>
                      <td>{debitoDetalhado.codigoCobranca}</td>
                      <td>{debitoDetalhado.codigoReceita}</td>
                      <td>{formatarData(debitoDetalhado.dataGeracao, "dd/MM/yyyy HH:MM:SS")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <b>Nenhum registro para exibir</b>
          )}
          ;
        </Col>
      </Row>
    </div>
  );
};

export default DebitoDetalhe;
